import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitConfigurationSubmissionData } from '../../../../../../models/submissions/variable-benefit-configuration-submission-data';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';
import { VariableBenefitDestinationJurisdictionDetail } from '../../../../../../models/submissions/variable-benefit-destination-jurisdiction-detail';
import { VariableBenefitRecurringPaymentRow } from '../../../vb-payment-change/interfaces/variable-benefit-recurring-payment-row';
import { VbRecurringPaymentProrationUtils } from '../../utils/vb-recurring-payment-proration.utils';

@Component({
  selector: 'app-vb-config-recurring-payments-review-card',
  templateUrl: './vb-config-recurring-payments-review-card.component.html',
  styleUrls: ['./vb-config-recurring-payments-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigRecurringPaymentsReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitConfigurationSubmissionData;
  @Input() estimatedAnnualTotal: number | null = null;

  public isMonthly = false;
  public rows: VariableBenefitRecurringPaymentRow[] = [];
  public total = 0;
  public annualTotal = 0;

  public ngOnChanges(): void {
    const details = this.submission?.destinationJurisdictions ?? [];
    this.isMonthly = this.submission?.recurringPaymentFrequencyId === VariableBenefitPaymentFrequencyEnum.Monthly;
    this.rows = details
      .filter(d => this.hasRecurringPayment(d))
      .map(d => this.toRow(d))
      .sort((a, b) => a.jurisdictionName.localeCompare(b.jurisdictionName));
    this.total = this.rows.reduce((sum, r) => sum + r.amount, 0);
    this.annualTotal =
      this.estimatedAnnualTotal ??
      this.total * VbRecurringPaymentProrationUtils.remainingPaymentMonths(this.submission?.recurringPaymentStartDate);
  }

  private hasRecurringPayment(detail: VariableBenefitDestinationJurisdictionDetail): boolean {
    return (
      detail.recurringPaymentUseMinimumAmount ||
      detail.recurringPaymentUseMaximumAmount ||
      detail.recurringPaymentAmount !== null
    );
  }

  private toRow(detail: VariableBenefitDestinationJurisdictionDetail): VariableBenefitRecurringPaymentRow {
    return {
      jurisdictionName: detail.governingJurisdiction?.name ?? $localize`Non-Locked-In`,
      amount: detail.recurringPaymentAmount ?? 0,
      paymentTypeLabel: this.resolvePaymentTypeLabel(detail)
    };
  }

  private resolvePaymentTypeLabel(detail: VariableBenefitDestinationJurisdictionDetail): string {
    if (detail.recurringPaymentUseMinimumAmount) {
      return $localize`Minimum`;
    }
    if (detail.recurringPaymentUseMaximumAmount) {
      return $localize`Maximum`;
    }
    return $localize`Custom`;
  }
}
